import React, {FunctionComponent, useState} from "react";
import {Menu, MenuItem} from "@mui/material";
import { connect } from "react-redux";
import SubMenuItem from "./menus/SubMenuItem";
import { NetworkData } from "../../fstn/network";

interface NavigationMenuProps
{
    anchor?: Element
    modeMenu?: FunctionComponent<any>
    name: string
    onClose: () => void
    onCloseProject: () => void
    onResetNetwork: () => void
    onShowDialog: (dialog: string) => void
    project: string
}
interface NavigationMenuRedux
{
    network?: NetworkData
}
type Props = NavigationMenuProps & NavigationMenuRedux;
function NavigationMenu({anchor, modeMenu, name, network, onClose, onCloseProject,onResetNetwork, onShowDialog, project}: Props)
{
    const [submenuOpen, setSubmenuOpen] = useState("");
    const handleResetClick = () =>
    {
        onClose();
        onResetNetwork();
    };
    const handleCloseProjectClick = () =>
    {
        onClose();
        onCloseProject();
    };
    const handleFindAndReplaceClick = () => {
        onClose();
        onShowDialog("find");
    }
    const handleShowProject = () =>
    {
        onClose();
        onShowDialog("project");
    };
    const handleClose = () => {
        onClose();
        setSubmenuOpen("");
    }
    const handleOpen = (subMenu: string) => () => {
        setSubmenuOpen(subMenu);
    }

    return (
        <>
            <Menu
                anchorEl={anchor} anchorOrigin={{ vertical: "top", horizontal: "right" }} keepMounted
                open={Boolean(anchor)} onClose={handleClose}>
                {network && <MenuItem onClick={handleResetClick}>Restart</MenuItem>}
                {!!project && <MenuItem onClick={handleShowProject}>Show project details</MenuItem>}
                {!!project && <MenuItem onClick={handleCloseProjectClick}>Close project</MenuItem>}
                {!!project && <MenuItem onClick={handleFindAndReplaceClick}>Find and Replace</MenuItem>}
                {modeMenu &&
                    <SubMenuItem menu={modeMenu} onClick={handleOpen(name)} onClose={handleClose}
                                 open={submenuOpen === name} text={`${name} Tools`}/>}
                </Menu>
        </>
    );
}
const mapStateToProps = (store: never) => ({
});

export default connect(mapStateToProps, {
})(NavigationMenu);
